const LIVE_MAX_ENTRIES = 1000;
const STORAGE_KEY = 'rpmLogsActiveTab';

let liveTimer = null;
let liveActive = false;
let liveLatestTs = null;
let $toggle;
let init;

function buildLiveUrl() {
  const params = new URLSearchParams($toggle.data('liveParams') || '');
  if (liveLatestTs) {
    params.set('since', liveLatestTs);
  }
  const base = $toggle.data('liveUrl');
  return base + (params.toString() ? '?' + params.toString() : '');
}

function pollLive() {
  if (!document.body.contains($toggle[0])) {
    stopLive();
    return;
  }
  // Self-scheduling: the next poll is only queued after this request settles, so a slow ES
  // response can never let two polls run concurrently with the same (stale) `since`, which
  // would re-fetch and duplicate the same entries.
  $.get(buildLiveUrl(), function (html) {
    const $html = $(html.trim());
    if (!$html.length) {
      return;
    }

    const newTs = $html.filter('.live-latest-ts').data('ts');
    if (newTs) {
      liveLatestTs = newTs;
    }

    const $contents = $('.logs-contents');
    $contents.prepend($html);

    const $entries = $contents.find('.live-log-line');
    if ($entries.length > LIVE_MAX_ENTRIES) {
      $entries.slice(LIVE_MAX_ENTRIES).remove();
    }

    init.register();
  }).always(function () {
    if (liveActive) {
      liveTimer = setTimeout(pollLive, 3000);
    }
  });
}

function startLive() {
  liveLatestTs = new Date().toISOString();
  liveActive = true;
  $toggle.addClass('active');
  pollLive();
}

function stopLive() {
  liveActive = false;
  clearTimeout(liveTimer);
  liveTimer = null;
  $toggle.removeClass('active');
}

function activateTab(tab) {
  $('#rpm-logs-tabs .item').removeClass('active');
  $('#rpm-logs-tabs .item[data-tab="' + tab + '"]').addClass('active');
  $('#rpm-logs-paginated-table .tab.segment').removeClass('active');
  $('#rpm-logs-paginated-table .tab.segment[data-tab="' + tab + '"]').addClass(
    'active',
  );
}

function initTabs() {
  activateTab(localStorage.getItem(STORAGE_KEY) || 'table');
  $('#rpm-logs-tabs .item')
    .off('click.rpmtabs')
    .on('click.rpmtabs', function () {
      const tab = $(this).data('tab');
      if (tab !== 'terminal' && liveTimer) {
        stopLive();
      }
      localStorage.setItem(STORAGE_KEY, tab);
      activateTab(tab);
    });
}

module.exports = function () {
  // The noise checkbox and search box read hx-vals via js:getRPMLogsHxVals(), which the
  // DatePicker component defines on mount. Provide a safe fallback so htmx never evaluates an
  // undefined function if it fires before the picker mounts. `||` keeps the real one once set.
  window.getRPMLogsHxVals =
    window.getRPMLogsHxVals ||
    function () {
      return {};
    };

  $toggle = $('#rpm-logs-live-toggle');
  init = new Initializer();

  $toggle.on('click', function () {
    liveActive ? stopLive() : startLive();
  });

  window.addEventListener('beforeunload', stopLive);

  initTabs();

  // Bind on the stable container, not on #rpm-logs-paginated-table: the pager/search swaps
  // replace .paginated-table itself (hx-swap outerHTML), which would destroy a listener bound
  // to it. The container survives and still catches afterSettle bubbling from the swapped-in
  // content, so React components in the new page get re-registered.
  $('#rpm-logs-table-container').on('htmx:afterSettle', function () {
    init.register();
    initTabs();
  });
};
